.select-user{margin-left:5px;border-bottom:1px dashed;cursor:pointer}.input-check>label{padding-left:5px}.sk-spinner{width:150px;height:150px}
/*# sourceMappingURL=invoices-form.component-P5N7WBSV.css.map */
